<template>
  <div class="filter-widget">
    <router-link :to="{name: 'shop'}" class="reset-filters">{{$t("shop.sidebar.reset_filters")}}</router-link>
  </div>
</template>

<script>
export default {
  props: ['title']
}
</script>
